var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#ed6f64;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2653.407 -5823.522)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2663.78,5834.52a.624.624,0,0,1-.442-.183l-5.745-5.746a.625.625,0,1,1,.884-.883l5.745,5.745a.625.625,0,0,1-.442,1.067Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2658.035,5834.52a.625.625,0,0,1-.442-1.067l5.745-5.745a.625.625,0,0,1,.884.883l-5.745,5.746A.623.623,0,0,1,2658.035,5834.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2660.907,5838.522a7.5,7.5,0,1,1,7.5-7.5A7.509,7.509,0,0,1,2660.907,5838.522Zm0-13.75a6.25,6.25,0,1,0,6.25,6.25A6.258,6.258,0,0,0,2660.907,5824.772Z",
    transform: "translate(-2653.407 -5823.522)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.ad838d80b42ab19e0a0f8afa89f33267.svg";
export { ForwardRef as ReactComponent };